/* FAETTON PRERENDER NAVIGATION V8 — real page navigation, no PJAX/drawer. */
(function(){
  'use strict';
  var doc = document;
  var win = window;
  var seen = win.FaettonPrerenderSeen || (win.FaettonPrerenderSeen = Object.create(null));

  function normalize(url){ try { return new URL(url, location.href); } catch(e){ return null; } }
  function safeProductHref(url){
    var u = normalize(url); if(!u) return '';
    if(u.origin !== location.origin) return '';
    if(!/\/products\//.test(u.pathname)) return '';
    if(/\/cart|\/checkout|\/account|\/admin|\/apps|\/search|\/challenge/.test(u.pathname)) return '';
    if(/(^|[?&])variant=/.test(u.search)) return '';
    return u.href.split('#')[0];
  }
  function addHint(rel, href, priority){
    if(!href) return;
    var key = rel + ':' + href;
    if(seen[key]) return;
    seen[key] = true;
    try{
      var l = doc.createElement('link');
      l.rel = rel;
      l.href = href;
      if(rel === 'prefetch') l.as = 'document';
      if(priority) l.fetchPriority = priority;
      doc.head.appendChild(l);
    }catch(e){}
  }
  function warm(url, level){
    var href = safeProductHref(url); if(!href) return;
    addHint('prefetch', href, level === 'hot' ? 'high' : 'low');
    /* rel=prerender is ignored by many browsers but harmless where unsupported.
       Chrome's main path is the Speculation Rules block in <head>. */
    if(level === 'hot') addHint('prerender', href, 'high');
  }
  function linkFromEvent(e){ return e && e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null; }

  doc.addEventListener('pointerover', function(e){ var a=linkFromEvent(e); if(a) warm(a.href, 'warm'); }, {passive:true});
  doc.addEventListener('focusin', function(e){ var a=linkFromEvent(e); if(a) warm(a.href, 'warm'); }, {passive:true});
  doc.addEventListener('touchstart', function(e){ var a=linkFromEvent(e); if(a) warm(a.href, 'hot'); }, {passive:true});
  doc.addEventListener('pointerdown', function(e){ var a=linkFromEvent(e); if(a) warm(a.href, 'hot'); }, {passive:true});

  function prewarmVisible(){
    var links = Array.prototype.slice.call(doc.querySelectorAll('a[href*="/products/"]')).filter(function(a){ return safeProductHref(a.href); });
    if(!links.length) return;
    if('IntersectionObserver' in win){
      var warmed = 0;
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting || warmed >= 16) return;
          warmed++;
          warm(entry.target.href, warmed <= 4 ? 'hot' : 'warm');
          io.unobserve(entry.target);
        });
      }, {rootMargin:'700px 0px'});
      links.slice(0, 40).forEach(function(a){ io.observe(a); });
    } else {
      links.slice(0, 8).forEach(function(a){ warm(a.href, 'warm'); });
    }
  }

  if(doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', prewarmVisible, {once:true});
  else prewarmVisible();

  /* Click remains native. We only create a tiny visual continuity layer; destination page loads normally,
     so Shopify apps, Kaching, cart, header, footer and all sections boot from a real document. */
  doc.addEventListener('click', function(e){
    var a = linkFromEvent(e);
    if(!a || !safeProductHref(a.href)) return;
    if(a.target && a.target !== '_self') return;
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    warm(a.href, 'hot');
    try { sessionStorage.setItem('faetton-real-page-nav', String(Date.now())); } catch(err){}
  }, true);

  win.addEventListener('pageshow', function(){
    try{
      var t = parseInt(sessionStorage.getItem('faetton-real-page-nav') || '0', 10);
      if(t && Date.now() - t < 7000){
        doc.documentElement.classList.add('faetton-prerender-arrival');
        setTimeout(function(){ doc.documentElement.classList.remove('faetton-prerender-arrival'); }, 650);
      }
    }catch(e){}
  });

})();
